import { useContext, useCallback } from 'react';
import { generateReplyEditorId } from '../../utils';
import { CommentContext } from '../../CommentContext';
/**
 * Every prop a reply comment box needs. Pass the returned props to your own `CommentBox` version and you're good to go!
 *
 * Returns `onPublishSuccess`, `onCancel`, and `id`
 *
 * Note: `onPublishSuccess` is usually passed directly to the CommentBoxSkeleton, but `onCancel` needs to be passed wherever you have your `useCommentCancelAction` is at.
 */
export function useReplyCommentBoxBase(_a) {
    var _b = _a === void 0 ? {} : _a, onPublishSuccess = _b.onPublishSuccess, onCancel = _b.onCancel;
    var _c = useContext(CommentContext), comment = _c.comment, setEditingState = _c.setEditingState;
    var onCloseEditor = useCallback(function () {
        setEditingState('none');
        onCancel && onCancel();
    }, [setEditingState, onCancel]);
    var onReplyDone = useCallback(function (result) {
        setEditingState('none');
        onPublishSuccess && result.comment && onPublishSuccess(result);
    }, [onPublishSuccess, setEditingState]);
    return {
        id: generateReplyEditorId(comment),
        onCancel: onCloseEditor,
        onPublishSuccess: onReplyDone,
    };
}
//# sourceMappingURL=useReplyCommentBoxBase.js.map